import type { ReactNode } from "react";
import { T } from "../tokens";
import { Han } from "./Han";
import { MonoLabel } from "./MonoLabel";

export type HudDirection = "instrument" | "letter";

export interface HUDProps {
  label: ReactNode;
  dir?: HudDirection;
  right?: ReactNode;
}

export function HUD({ label, dir = "instrument", right }: HUDProps) {
  return (
    <div
      style={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "baseline",
        padding: "64px 28px 0",
        gap: 12,
        minHeight: 64,
      }}
    >
      {dir === "instrument" ? (
        <MonoLabel size={11}>{label}</MonoLabel>
      ) : (
        <Han size={12} ls="0.02em" color={T.ink500}>
          {label}
        </Han>
      )}
      {right || <span />}
    </div>
  );
}
